export default {
  headData: '/v3/recommend/front/broadcast',
  inviteList: '/v3/recommend/front/inviteList',
  contact: '/v3/recommend/getContactCount',
  invite: '/v3/recommend/invite',
  confirmContact: '/v3/recommend/confirmContact',
  queryRecommendWords: '/v3/invite/courier/invite/recommended/queryRecommendWords'
}
